// src/hooks/useAuth.js
import { useContext } from "react";
import { AuthContext } from "../Context/AuthContext";

const useAuth = () => {
  const {
    auth,
    permissions,
    role,
    name,
    setAuth,
    clearAuth,
    fetchPermissions,
    access,
    userId,
  } = useContext(AuthContext);

  return {
    auth,
    permissions,
    role,
    name,
    setAuth,
    clearAuth,
    fetchPermissions,
    access,
    userId,
  };
};

export default useAuth;
